// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"8223":"332e47af9e15ef52","9236":"660608da1c7798c1"}[chunkId] + ".css";
};